import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";

const groups = [
  {
    title: "Explore",
    links: [
      { label: "How It Works", href: "/how-it-works" },
      { label: "Solutions", href: "/solutions" },
      { label: "Why UniqReach", href: "/why-uniqreach" },
      { label: "Results", href: "/results" },
    ],
  },
  {
    title: "Technology",
    links: [
      { label: "AI & Automation", href: "/technology/ai-automation" },
      { label: "Data & Prospecting", href: "/technology/data-prospecting" },
      {
        label: "Outbound Infrastructure",
        href: "/technology/outbound-infrastructure",
      },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "FAQ", href: "/faq" },
      { label: "Contact", href: "/contact" },
      { label: "Book a Strategy Call", href: "/book" },
    ],
  },
];
export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand-link" aria-label="UniqReach home">
              <img
                src="/uniqreach-mark.svg"
                className="brand-mark"
                width="58"
                height="30"
                alt=""
              />
              <span>UniqReach</span>
            </Link>
            <p className="footer-positioning">Sales Systems for B2B Tech</p>
            <p>
              AI-powered outbound systems that connect your data, tools, and
              sales process.
            </p>
            <a href="mailto:hello@uniqreach.com" className="footer-contact">
              <Mail size={17} aria-hidden="true" />
              hello@uniqreach.com
              <ArrowUpRight size={16} aria-hidden="true" />
            </a>
          </div>
          {groups.map((group) => (
            <nav key={group.title} aria-label={`${group.title} footer links`}>
              <h2 className="label">{group.title}</h2>
              <ul>
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} UniqReach. All rights reserved.</p>
          <nav aria-label="Legal links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
